var map = {
	"./Twitter.svg": 7276,
	"./codewars.svg": 3652,
	"./devto.svg": 3328,
	"./facebook.svg": 9387,
	"./freecodecamp.svg": 7111,
	"./frontendmentor.svg": 4585,
	"./github.svg": 2188,
	"./gitlab.svg": 5752,
	"./hashnode.svg": 5627,
	"./linkedin.svg": 4126,
	"./stackoverflow.svg": 1528,
	"./twitch.svg": 9240,
	"./youtube.svg": 7140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4636;